import { cn } from "@/lib/cn";

export type Family = "tabular" | "anomaly" | "forecast";

interface FamilyBadgeProps {
  family: Family | null;
}

export function FamilyBadge({ family }: FamilyBadgeProps) {
  if (family === null) {
    return null;
  }

  return (
    <span
      className={cn(
        "inline-flex items-center justify-center",
        "px-2 py-0.5 rounded",
        "bg-zinc-100 dark:bg-zinc-800",
        "border border-zinc-300 dark:border-zinc-700",
        "font-mono text-[10px] uppercase tracking-wider",
        "text-zinc-700 dark:text-zinc-300",
      )}
    >
      {family}
    </span>
  );
}
